var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 233,
    viewBox: "0 0 233 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2551_16975)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.623 43.9095C146.488 42.6963 144.902 42.0078 143.241 42.0078H47.002C43.6882 42.0078 41.002 44.6941 41.002 48.0078V111.008C41.002 114.322 43.6882 117.008 47.002 117.008H50.002C53.3157 117.008 56.002 114.322 56.002 111.008V63.0078C56.002 59.6941 58.6882 57.0078 62.002 57.0078H125.002C128.316 57.0078 131.002 59.6941 131.002 63.0078V96.0078C131.002 99.3215 133.688 102.008 137.002 102.008H170.002C173.316 102.008 176.002 104.694 176.002 108.008V111.008C176.002 114.322 178.688 117.008 182.002 117.008H185.002C188.316 117.008 191.002 114.322 191.002 111.008V92.6612C191.002 91.1394 190.424 89.6744 189.384 88.5629L147.623 43.9095Z",
    fill: "#47AD1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6154 163.542C85.6154 182.456 76.2663 189 58.431 189H42.1061V138.659H59.7255C75.5471 138.659 85.6154 144.628 85.6154 163.542ZM71.3041 163.757C71.3041 154.48 68.3555 150.597 59.6536 150.597H56.2016V177.062H59.2221C67.924 177.062 71.3041 173.754 71.3041 163.757ZM138.523 163.757C138.523 180.514 128.814 189.791 115.15 189.791C101.486 189.791 91.921 180.658 91.921 163.901C91.921 147.145 101.63 137.868 115.294 137.868C128.958 137.868 138.523 147.001 138.523 163.757ZM124.068 163.901C124.068 154.84 120.759 150.021 115.15 150.021C109.54 150.021 106.376 154.696 106.376 163.757C106.376 172.819 109.684 177.637 115.294 177.637C120.903 177.637 124.068 172.963 124.068 163.901ZM188.463 176.774C185.083 183.391 179.473 189.791 167.535 189.791C152.577 189.791 144.594 178.716 144.594 163.829C144.594 147.648 154.087 137.868 167.607 137.868C179.977 137.868 184.867 143.189 188.319 152.682L175.662 157.645C173.864 152.97 172.138 150.021 167.535 150.021C161.71 150.021 159.193 155.847 159.193 163.829C159.193 171.524 161.638 177.637 167.679 177.637C172.066 177.637 173.936 175.264 176.669 170.518L188.463 176.774Z",
    fill: "#47AD1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2551_16975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(41 42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/Doc.2336d13ee213a9330305f9c82b47f69f.svg";
export { ForwardRef as ReactComponent };